import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { getLivekitRoomDetails } from 'services/api/getLIvekitRoomDetails';

export const useGetLivekitRoomDetails = (callID: string, isEnabled: boolean) => {
    const { data, isLoading, refetch, ...rest } = useQuery({
        queryKey: queryKeys.livekitRoomDetails(callID),
        queryFn: () => getLivekitRoomDetails(callID),
        enabled: isEnabled && !!callID,
    });

    return {
        livekitRoomDetails: data,
        isLoadingLivekitRoomDetails: isLoading,
        refetchLivekitRoomDetails: refetch,
        ...rest,
    };
};
